"use client";

import { Check, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Pricing() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: reassuranceRef,
    isVisible: reassuranceVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="124" id="pricingoverview" className="relative overflow-hidden bg-background py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0 opacity-40" aria-hidden="true">
        <div className="absolute left-1/2 top-0 h-[500px] w-[800px] -translate-x-1/2 rounded-lg bg-[radial-gradient(ellipse_at_center,var(--primary)_0%,transparent_70%)] opacity-20 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[400px] w-[600px] rounded-lg bg-[radial-gradient(ellipse_at_center,var(--chart-2)_0%,transparent_70%)] opacity-10 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="mb-5 inline-flex items-center gap-2 rounded-md border border-border bg-card px-3 py-1 text-xs font-medium text-muted-foreground font-mono uppercase tracking-wider">
            <Sparkles className="size-3 text-primary" />
            Unsere Leistungen
          </div>
          <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">Service-Pakete</h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
            Lösungen für Fahrzeugschlüssel.
          </p>
        </div>

        <div ref={gridRef} className={`mx-auto mt-20 grid max-w-md grid-cols-1 gap-8 lg:max-w-7xl lg:grid-cols-3 lg:items-stretch transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          

          <div data-index={1} className="relative flex h-full flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">Variante 1: Schlüssel bereits vorhanden</div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 100 €</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Fräsen &amp; Anlernen von 1 Schlüssel am Fahrzeug inkl. 30 km Anfahrt.</p>

              <ul className="mt-8 flex flex-col gap-4">
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Vorhanden Schlüssel direkt vor Ort am Fahrzeug Fräsen und Anlernen&nbsp;</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Hinweis: Der Schlüssel muss fahrzeugkompatibel und funktionsfähig sein</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">+ 25 € → Jeder weitere Schlüssel am selben Termin<br /></span>
                </li>
              </ul>

              <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                <div>
                  <p className="font-bold text-foreground">Anfahrt & Mehrkilometer</p>
                  <p>30 km inklusive</p>
                  <p>Ab dem 31. km berechnen wir 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></p>
                  
                </div>
              </div>

              <Button asChild size="lg" className="mt-auto w-full bg-primary text-white hover:bg-primary/90">
                <Link to="/ContactPage">Jetzt anfragen</Link>
              </Button>
            </div>
          </div><div data-index={1} className="relative flex h-full flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">
                Variante 2: Komplettangebot – kein Schlüssel vorhanden
              </div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 150 €</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Neuer Fahrzeugschlüssel inklusive Fräsen und Anlernen am Fahrzeug inkl. 30 km Anfahrt.</p>

              <ul className="mt-8 flex flex-col gap-4">
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Der Endpreis richtet sich nach Fahrzeugmodell, Hersteller und Schlüsseltyp</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Fräsen und Anlernen direkt am Fahrzeug vor Ort</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">1 neuer Fahrzeugschlüssel inklusive<br /><br /></span>
                </li>
              </ul>

              <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                <div>
                  <p className="font-bold text-foreground">Anfahrt & Mehrkilometer</p>
                  <p>30 km inklusive</p>
                  <p>Ab dem 31. km berechnen wir 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></p>
                  
                </div>
              </div>

              <Button asChild size="lg" className="mt-auto w-full bg-primary text-white hover:bg-primary/90">
                <Link to="/ContactPage">Jetzt anfragen</Link>
              </Button>
            </div>
          </div>

          <div data-index={2} className="relative flex h-full flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">NEUEN Bart FRÄSEN / FÜR VORHANDENE ROHLINGE</div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 10 €</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Fräsen eines vorhandenen Schlüsselrohlings passend zum Fahrzeug.</p>

              <ul className="mt-8 flex flex-col gap-4">
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Fräsen nach vorhandenem Muster/Schlüssel<br /><br /></span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Der mitgebrachte Rohling muss baugleich mit dem vorhandenen Fahrzeugschlüssel sein.</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground"><span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow" data-ast-id="f:/src/pages/KeyService/sections/Pricing.tsx|sig:5qkm2y" data-ast-start="10006" data-ast-end="10273"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check size-3" aria-hidden="true" data-ast-id="f:/src/pages/KeyService/sections/Pricing.tsx|sig:t2nfge" data-ast-start="10203" data-ast-end="10247"><path d="M20 6 9 17l-5-5"></path></svg></span><span className="leading-relaxed" data-ast-id="f:/src/pages/KeyService/sections/Pricing.tsx|sig:esr3o" data-ast-start="10292" data-ast-end="10375">Kein Anlernen oder Programmieren enthalten<br /><br /></span></li>
              </ul>

              <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                <div>
                  <p className="font-bold text-foreground">Vor-Ort-Service</p>
                  <div className="space-y-1">
                    <p>Vor-Ort-Service nach Absprache möglich.</p>
                    <div>Anfahrt: 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></div>
                    
                    
                  </div>
                </div>
              </div>

              <Button asChild size="lg" className="mt-auto w-full bg-primary text-white hover:bg-primary/90">
                <Link to="/ContactPage">Jetzt anfragen</Link>
              </Button>
            </div>
          </div>

          <div data-index={3} className="relative flex h-full flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">SCHLÜSSELBATTERIE WECHSELN<br /><br /></div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 20 €</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Wechsel der Schlüsselbatterie für viele Fahrzeugmarken.</p>

              <ul className="mt-8 flex flex-col gap-4">
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Austausch der Schlüsselbatterie<br /><br /></span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Funktionsprüfung des Fahrzeugschlüssels<br /><br /></span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Geeignete Batterien direkt vor Ort verfügbar<br /><br /></span>
                </li>
              </ul>

              <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                <div>
                  <p className="font-bold text-foreground">Vor-Ort-Service</p>
                  <div className="space-y-1">
                    <p>Vor-Ort-Service nach Absprache möglich.</p>
                    <div>Anfahrt: 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></div>
                    
                    
                  </div>
                </div>
              </div>

              <Button asChild size="lg" className="mt-auto w-full bg-primary text-white hover:bg-primary/90">
                <Link to="/ContactPage">Jetzt anfragen</Link>
              </Button>
            </div>
          </div>
          
          <div data-index={4} className="relative flex h-full flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">SCHLÜSSELGEHÄUSE WECHSELN<br /><br /></div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 25 €</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Erneuerung eines beschädigten oder defekten Schlüsselgehäuses.</p>

              <ul className="mt-8 flex flex-col gap-4">
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Austausch des Schlüsselgehäuses<br /><br /></span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Übernahme von Elektronik und Transponder<br /><br /></span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Funktionsprüfung des Fahrzeugschlüssels<br /><br /></span>
                </li>
              </ul>

              <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                <div>
                  <p className="font-bold text-foreground">Vor-Ort-Service</p>
                  <div className="space-y-1">
                    <p>Vor-Ort-Service nach Absprache möglich.</p>
                    <div>Anfahrt: 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></div>
                    
                    
                  </div>
                </div>
              </div>

              <Button asChild size="lg" className="mt-auto w-full bg-primary text-white hover:bg-primary/90">
                <Link to="/ContactPage">Jetzt anfragen</Link>
              </Button>
            </div>
          </div>

          <div data-index={5} className="relative flex h-full flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">MIKROTASTER WECHSELN<br /><br /></div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 40 €</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Austausch defekter Mikrotaster an Fahrzeugschlüsseln.</p>

              <ul className="mt-8 flex flex-col gap-4">
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Austausch defekter Mikrotaster<br /><br /></span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Funktionsprüfung aller Tasten<br /><br /></span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground">
                  <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                    <Check className="size-3" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed">Je nach Bauart des Schlüssels möglich<br /><br /></span>
                </li>
              </ul>

              <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                <div>
                  <p className="font-bold text-foreground">Vor-Ort-Service</p>
                  <div className="space-y-1">
                    <p>Vor-Ort-Service nach Absprache möglich.</p>
                    <div>Anfahrt: 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></div>
                    
                    
                  </div>
                </div>
              </div>

              <Button asChild size="lg" className="mt-auto w-full bg-primary text-white hover:bg-primary/90">
                <Link to="/ContactPage">Jetzt anfragen</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}